module.exports = __webpack_public_path__ + "media/assets/google-7135c32a851b48d667e8487dbba86561.svg";